// ALL THE ROUTES USED IN THE APP

export const apiRoutes = {

    login: '/login',
    addVehicle: '/add_vehicle',
    getAllVehicles: '/get_all_vehicles',
    getVehicleDetails: '/get_vehicle_details',
    getBookingRequests: '/get_bookings_req',
    changeBookingStatus: '/change_booking_status',
    getBookedVehicles: '/get_booked_vehicles',
    getAgreementData: '/get_agreement_data',
    generateAgreement: '/generate_agreement',
    moveVehicleTrash: '/move_vehicle_trash',
    getAllInvoices: '/get_all_invoices_admin',
    getTransactionDetails: '/get_transaction_details',
    changeTransactionStatus: '/change_transaction_status',
    getAllUsers: '/get_all_users',
    editVehicle: '/edit_vehicle',
    getNotif: '/get_admin_notif',
    getClientsAndVehicles: '/get_clients_vehicles',
    addInvoice: '/add_invoice',
    cancelInvoice: '/cancel_invoice',
    deleteAgreement: '/delete_agreement',
    moveVehicleToTrash: '/move_vehicle_to_trash',
    closeAgreement: '/close_agreement',
    getCustDetails: '/get_cust_details',
    getDashboard: '/get_dashboard_admin',
    logout: '/admin_logout',
    updateCustomer: '/update_customer',
    getDeletedVehicles: '/get_deleted_vehicles',
    restoreVehicle: '/restore_vehicle',
    checkBookingStatusForApprove: '/check_booking_status_for_approve',
    getCustInvoices: '/get_cust_invoices',
    deleteBookingRequest: '/delete_booking_request',
    
    addAgreementNote: '/add_agreement_note',
    getAgreementNotes: '/get_agreement_notes',
    updateAgreementNote: '/update_agreement_note',
    deleteAgreementNote: '/delete_agreement_note',
    
    addCustomerNotes: '/add_customer_note',
    getCustomerNotes: '/get_customer_notes',
    updateCustomerNote: '/update_customer_note',
    deleteCustomerNote: '/delete_customer_note',

    addVehicleNotes: '/add_vehicle_note',
    getVehicleNotes: '/get_vehicle_notes',
    updateVehicleNote: '/update_vehicle_note',
    deleteVehicleNote: '/delete_vehicle_note',

    getUpcomingMots: '/get_upcoming_mots',

    getVehicleRentalHistory: '/get_vehicle_history',
    getCustomerRentalReport: '/get_customer_report',
    signup: '/user_signup',




    getMyCars: '/get_my_cars',
    bookingRequest: '/booking_request',
    getVehicles: '/get_vehicles',
    // getDashboard: '/get_dashboard',
    getNotifs: '/get_cust_notifications',
    getInvoices: '/get_all_invoices',
    getVehInvoices: '/get_vehicle_invoices',
    payInvoice: '/pay_invoice',
    getAllAgreements: '/get_all_agreements',
    extendAgreement: '/extend_agreement',
    regenerateAgreement: '/regenerate_agreement',
    getAgreementHistory: '/get_agreement_history',
    deleteAgreementVersions: '/delete_agreement_versions',
    editCustomer: '/edit_customer'





}